import { apiClient } from '../client';
import type { Event } from './bars';

interface EventsListResponse {
  success: boolean;
  events: (Event & { barName?: string; barAddress?: string; barLogoUrl?: string; distance?: number })[];
  total: number;
  limit: number;
  offset: number;
}

interface ListEventsParams {
  search?: string;
  lat?: number;
  lng?: number;
  radius?: number;
  limit?: number;
  offset?: number;
}

export const eventsApi = {
  list: async (params: ListEventsParams = {}): Promise<EventsListResponse> => {
    const { data } = await apiClient.get<EventsListResponse>('/v1/events', {
      params,
    });
    return data;
  },

  getById: async (id: string) => {
    const { data } = await apiClient.get(`/v1/events/${id}`);
    return data;
  },
};
